import { defineMessages } from 'react-intl';

export default defineMessages({
    interestedParty: {
        id: 'ml.quoteandbind.common.additionalInterest.Interested Party',
        defaultMessage: 'Interested Party #{number}'
    },
    interestedPartyType: {
        id: 'ml.quoteandbind.common.additionalInterest.Interested Party Type',
        defaultMessage: 'Interested Party Type'
    },
    removeInterestedParty: {
        id: 'ml.quoteandbind.common.additionalInterest.Remove Interested Party',
        defaultMessage: 'Remove Interested Party'
    },
    typeOfInterestedPartyType: {
        id: 'ml.quoteandbind.common.additionalInterest.Type Of',
        defaultMessage: 'Type of {interestedPartyType}'
    },
    individual: {
        id: 'ml.quoteandbind.common.additionalInterest.Individual',
        defaultMessage: 'Individual'
    },
    business: {
        id: 'ml.quoteandbind.common.additionalInterest.Business',
        defaultMessage: 'Business'
    },
    companyNameLabel: {
        id: 'ml.quoteandbind.common.additionalInterest.companyNameLabel',
        defaultMessage: '{interestedPartyType} Name'
    },
    loanLabel: {
        id: 'ml.quoteandbind.common.additionalInterest.Loan #',
        defaultMessage: 'Loan # (optional)'
    },
    pound: {
        id: 'ml.quoteandbind.common.additionalInterest.pound',
        defaultMessage: '#'
    },
    selectYour: {
        id: 'ml.quoteandbind.common.additionalInterest.Select Your',
        defaultMessage: 'Select your {interestedPartyType}'
    },
    other: {
        id: 'ml.quoteandbind.common.additionalInterest.Other',
        defaultMessage: 'Other'
    },
    select: {
        id: 'ml.quoteandbind.common.additionalInterest.Select',
        defaultMessage: 'Select'
    },
    addNew: {
        id: 'ml.quoteandbind.common.additionalInterest.Name not listed - Add new',
        defaultMessage: 'Name not listed - Add new'
    },
    communicationPreferences: {
        id: 'ml.quoteandbind.common.additionalInterest.Communication Preferences',
        defaultMessage: 'Communication Preferences'
    },
    policyBillingDocuments: {
        id: 'ml.quoteandbind.common.additionalInterest.Policy/Billing Documents',
        defaultMessage: 'Policy/Billing Documents'
    },
    primaryEmail: {
        id: 'ml.quoteandbind.common.additionalInterest.Primary Email',
        defaultMessage: 'Primary Email'
    },
    propertyDescription: {
        id: 'ml.quoteandbind.common.additionalInterest.Property Description',
        defaultMessage: 'Property Description'
    },
    secondaryEmail: {
        id: 'ml.quoteandbind.common.additionalInterest.Secondary Email',
        defaultMessage: 'Secondary Email'
    },
    streetAddress: {
        id: 'ml.youraddress.addressdetails.Street address',
        defaultMessage: 'Street address'
    },
    aptUnitLabel: {
        id: 'ml.youraddress.addressdetails.Apt/Unit#',
        defaultMessage: 'Apt/Unit#'
    },
    postCodeHash: {
        id: 'ml.youraddress.addressdetails.#####',
        defaultMessage: '#####'
    },
    leasingCompany: {
        id: 'ml.quoteandbind.common.additionalInterest.Leasing Company',
        defaultMessage: 'Leasing Company'
    },
    lessorCompany: {
        id: 'ml.quoteandbind.common.additionalInterest.Lessor Company',
        defaultMessage: 'Lessor Company'
    },
    additional_insured_slp_ml: {
        id: 'ml.quoteandbind.common.additionalInterest.Additional Insured',
        defaultMessage: 'Additional Insured'
    },
    lienholderCompany: {
        id: 'ml.quoteandbind.common.additionalInterest.Lienholder Company',
        defaultMessage: 'Lienholder Company'
    },
    mortgageCompany: {
        id: 'ml.quoteandbind.common.additionalInterest.Mortgage Company',
        defaultMessage: 'Mortgage Company'
    },
    thirdPartyAlertMessage: {
        id: 'ml.quoteandbind.common.additionalInterest.thirdPartyAlertMessage',
        defaultMessage: 'You will receive a Notice of Right to Authorize Another Individual form to complete and return.  The interested party will be added to your policy once the form has been signed and returned.'
    },
    editItem: {
        id: 'ml.quoteandbind.common.additionalInterest.editItem',
        defaultMessage: 'Edit {item}'
    },
    addItem: {
        id: 'ml.quoteandbind.common.additionalInterest.addItem',
        defaultMessage: 'Add {item}'
    },
    emailAddress: {
        id: 'ml.quoteandbind.common.additionalInterest.Email Address',
        defaultMessage: 'Email Address'
    },
    invalidEmail:{
        id:'ml.quoteandbind.common.additionalInterest.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    describedProperty: {
        id: 'ml.quoteandbind.common.additionalInterest.Described Property',
        defaultMessage: 'Described Property'
    }
});
